import axios from 'axios'
import config from '../config'
import vuetifyToast from 'vuetify-toast'

export default {

  request (method, uri, data = null, location = null, overrideUrl = false) {
    if (!method) {
      console.error('API function call requires method argument')
      return
    }

    if (!uri) {
      console.error('API function call requires uri argument')
      return
    }
    var url = uri
    if (!overrideUrl) {
      url = config.serverURI + uri
    }
    return axios({ method, url, data }).then(response => {
      return response
    }).catch(error => {
      var color

      var errormessage = 'Um erro ocorreu na comunicação com o servidor'
      window.myApp.$raven.captureException(error)
      if (error.response.status === 400) {
        errormessage = error.response.request.response
        color = 'error'
      }
      if (error.response.status === 500) {
        errormessage = 'Ops... Erro interno do servidor. Favor comunique o suporte'
        color = 'error'
      }
      if (location === 'login') {
        if (error.response.status === 400) {
          errormessage = 'Nome de usuário ou senha incorretos'
          color = 'error'
        } else {
          errormessage = 'Servidor parece estar offline, tente novamente mais tarde'
          color = 'error'
          window.myApp.$raven.setUserContext({
            user: window.myApp.$store.state.user,
            role: window.myApp.$store.state.selectedRole
          })
        }
        if (error.response.status === 500) {
          errormessage = 'Email de recuperação enviado'
          color = 'success'
        }
      } else {
        window.myApp.$raven.setUserContext({
          user: window.myApp.$store.state.user,
          role: window.myApp.$store.state.selectedRole
        })
      }
      vuetifyToast.show({
        text: errormessage,
        color: color,
        timeout: 4000,
        dismissible: true
      })
      throw error
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js